export default "__VITE_ASSET__FEUHYjxI__"